<template>
    <div class="snack-login-page">
        <header class="snack-topbar">
            <div class="brand" aria-label="卓越鼎锋咨询与新商路休食品类专业版">
                <div class="brand-mark" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none"><path d="M5 8.5 12 5l7 3.5v7L12 19l-7-3.5v-7Z" stroke="currentColor" stroke-width="1.7"/><path d="m5.5 8.8 6.5 3.3 6.5-3.3M12 12.1V19" stroke="currentColor" stroke-width="1.7"/><path d="m8.5 6.8 6.8 3.5" stroke="currentColor" stroke-width="1.7"/></svg>
                </div>
                <div class="brand-text">
                    <div class="brand-copy">
                        <span class="brand-name">卓越鼎锋咨询&amp;新商路</span>
                        <span class="edition">休食品类专业版</span>
                    </div>
                </div>
            </div>
            <div class="header-slogan">
                <span>让管理更轻松，让经营更精准，让利润增长更容易</span>
                <strong>休食经销商用了都说好！</strong>
            </div>
            <div class="top-actions">
                <!-- 暂时隐藏：使用帮助 -->
                <a v-if="false" class="top-link" href="javascript:void(0)">
                    <svg viewBox="0 0 24 24" fill="none"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" stroke="currentColor" stroke-width="1.7"/><path d="M9.6 9a2.5 2.5 0 1 1 4.4 1.6c-.9.8-2 1.2-2 2.7M12 17h.01" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>
                    使用帮助
                </a>
                <div class="service">
                    <span>7×24小时服务热线</span>
                    <strong>400-683-6993</strong>
                </div>
            </div>
        </header>

        <div class="snack-stage">
            <div class="snack-card">
                <div class="snack-hero">
                    <div class="hero-portrait" aria-hidden="true">
                        <img src="@/assets/image/login/zhangfeng-portrait.png" alt="">
                    </div>
                    <div class="hero-inner">
                        <div class="hero-kicker">休闲食品经销商利润增长与自运营系统</div>
                        <h1>这不是一套记录经营结果的软件，<br>而是一套<em>推动经营结果发生</em>的系统。</h1>
                        <p class="hero-desc">咨询解决“应该怎么干”，系统解决“每天谁来干、干没干、干得怎么样、如何持续干”。张锋老师把<strong>咨询、管理、经营与休食品类实战经验</strong>真正沉淀进软件。</p>

                        <section class="feature-carousel" aria-label="系统四大特色轮播">
                            <div class="feature-stage">
                                <article
                                    v-for="(item, i) in featureList"
                                    :key="item.index"
                                    class="feature-slide"
                                    v-show="featureIndex === i"
                                >
                                    <div class="slide-copy">
                                        <span class="slide-index">{{ item.index }}</span>
                                        <h2>{{ item.title }}</h2>
                                        <p>{{ item.desc }}</p>
                                        <ul class="feature-details" v-if="item.details && item.details.length">
                                            <li v-for="(d, di) in item.details" :key="di">
                                                <strong>{{ d.label }}</strong>
                                                <span>{{ d.text }}</span>
                                            </li>
                                        </ul>
                                        <div class="feature-points" :class="{ 'strategy-line': item.strategy }" v-if="item.tags && item.tags.length">
                                            <span
                                                v-for="(tag, ti) in item.tags"
                                                :key="ti"
                                                :class="{ 'metric-highlight': item.highlights && item.highlights.indexOf(tag) > -1 }"
                                            >{{ tag }}</span>
                                        </div>
                                        <p class="feature-value" v-if="item.value">{{ item.value }}</p>
                                    </div>
                                    <div class="slide-visual" v-html="item.visual"></div>
                                </article>
                            </div>
                            <div class="carousel-bar">
                                <div class="feature-nav">
                                    <button
                                        v-for="(item, i) in featureList"
                                        :key="'dot-' + i"
                                        class="feature-dot"
                                        type="button"
                                        :aria-current="featureIndex === i ? 'true' : 'false'"
                                        @click="setFeature(i)"
                                    ><b>{{ item.navNo }}</b>{{ item.nav }}</button>
                                </div>
                                <div class="carousel-arrows">
                                    <button class="carousel-arrow" type="button" aria-label="上一项特色" @click="prevFeature">←</button>
                                    <button class="carousel-arrow" type="button" aria-label="下一项特色" @click="nextFeature(true)">→</button>
                                </div>
                            </div>
                        </section>

                        <div class="category-ribbon">
                            <strong>休食品类专版</strong>
                            <span>定量休食</span>
                            <span>散称包装货</span>
                            <span>散称裸货糕点</span>
                            <span>网红品</span>
                        </div>

                        <div class="proof-row">
                            <div class="expert-avatar">
                                <img src="@/assets/image/login/zhangfeng-portrait.png" alt="张锋">
                            </div>
                            <div class="expert-copy">
                                <strong>张锋 · 经销商生意发展研究院院长</strong>
                                <span>从战略、管理、软件工具、品类整合供应、精细化运营一体化赋能</span>
                            </div>
                            <div class="proof-stats">
                                <div class="proof-stat"><b>17年</b><small>快消品深耕</small></div>
                                <div class="proof-stat"><b>上百家</b><small>商贸公司成功陪跑</small></div>
                                <div class="proof-stat"><b>上万家</b><small>经销商培训经验</small></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="snack-login-side">
                    <div class="login-wrap" v-if="!isReset">
                        <div class="login-eyebrow">WELCOME BACK</div>
                        <h2 class="login-title">欢迎登录新商路</h2>
                        <p class="login-sub">进入休食品类精细化经营工作台</p>

                        <div class="tabs" role="tablist" aria-label="登录方式">
                            <button class="tab" type="button" role="tab" :aria-selected="params.loginWay == '0'" @click="switchLoginTab('0')">密码登录</button>
                            <button class="tab" type="button" role="tab" :aria-selected="params.loginWay == '1'" @click="switchLoginTab('1')">验证码登录</button>
                            <button class="tab" type="button" role="tab" :aria-selected="params.loginWay == '3'" @click="switchLoginTab('3')">扫码登录</button>
                        </div>

                        <template v-if="params.loginWay == '3'">
                            <div class="qr-panel">
                                <div class="qr">
                                    <el-image ref="qrCode" v-loading="codeLoading" :src="imgUrl" fit="contain"></el-image>
                                    <div class="qr-error" v-if="isOverdue">
                                        <p>二维码已过期</p>
                                        <div class="qr-btn" @click="getQrCode">刷新</div>
                                    </div>
                                </div>
                                <strong>使用新商路移动端扫码登录</strong>
                                <span>请使用手机 App 扫描二维码</span>
                            </div>
                        </template>

                        <template v-else-if="params.loginWay == '1'">
                            <el-form class="snack-form" ref="formPhone" :model="formPhone" :rules="rulesPhone" label-width="0px">
                                <el-form-item prop="phone" :error="errorMsg">
                                    <span class="field-label">手机号</span>
                                    <el-input class="snack-input" v-model.number="formPhone.phone" maxlength="11" placeholder="请输入手机号" clearable></el-input>
                                </el-form-item>
                                <el-form-item prop="smsVerificationCode" class="code-item">
                                    <span class="field-label">短信验证码</span>
                                    <el-input class="snack-input" v-model.number="formPhone.smsVerificationCode" maxlength="6" placeholder="请输入验证码"></el-input>
                                    <div class="code-text-abs" v-if="!isSend" @click="toSend">获取验证码</div>
                                    <div class="code-text-abs no" v-if="isSend">重新发送{{ count }}s</div>
                                </el-form-item>
                                <el-form-item>
                                    <div class="login-btn" @click="submitForm('formPhone')">登录系统 <span aria-hidden="true">→</span></div>
                                </el-form-item>
                            </el-form>
                        </template>

                        <template v-else>
                            <el-form class="snack-form" ref="formPass" :model="formPass" :rules="rulesPass" label-width="0px">
                                <el-form-item prop="userName" :error="errorMsg">
                                    <span class="field-label">账号 / 手机号</span>
                                    <el-input class="snack-input" v-model="formPass.userName" placeholder="请输入账号或手机号" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');"></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <span class="field-label">登录密码</span>
                                    <el-input class="snack-input" v-model="formPass.password" placeholder="请输入登录密码" autocomplete="off" show-password></el-input>
                                </el-form-item>
                                <el-form-item prop="status" class="slider-item">
                                    <silder-verify @success="handleSuccess" @mouseDown="handleMouseDown" :status="formPass.status"></silder-verify>
                                </el-form-item>
                                <el-form-item prop="rememberUserName" class="form-options">
                                    <el-checkbox v-model="formPass.rememberUserName" true-label="Y" false-label="N">记住登录状态</el-checkbox>
                                    <p class="forgot" @click="toChange">忘记密码？</p>
                                </el-form-item>
                                <el-form-item>
                                    <div class="login-btn" @click="submitForm('formPass')">登录系统 <span aria-hidden="true">→</span></div>
                                </el-form-item>
                            </el-form>
                        </template>

                        <div class="agree-box">
                            登录即表示已阅读并同意
                            <a href="http://rxy.rxysoft.com/rxy/userAgreement.html" target="_blank">《用户服务协议》</a>
                            和
                            <a href="http://rxy.rxysoft.com/rxy/privacy.html" target="_blank">《隐私政策》</a>
                        </div>
                    </div>

                    <div class="login-wrap reset-wrap" v-else>
                        <div class="login-eyebrow">RESET PASSWORD</div>
                        <h2 class="login-title">重置密码</h2>
                        <p class="login-sub">验证身份后设置新密码</p>

                        <div class="step">
                            <div class="step-top">
                                <div class="line" :class="stepIndex <= 2 ? 'active' : ''"></div>
                                <div class="circle" :class="stepIndex <= 2 ? 'active' : ''">1</div>
                                <div class="line1" :class="stepIndex == 2 ? 'active' : ''"></div>
                                <div class="circle" :class="stepIndex == 2 ? 'active' : ''">2</div>
                                <div class="line" :class="stepIndex == 2 ? 'active' : ''"></div>
                            </div>
                            <div class="step-bottom">
                                <p :class="stepIndex <= 2 ? 'active' : ''">身份验证</p>
                                <p :class="stepIndex == 2 ? 'active' : ''">修改密码</p>
                            </div>
                        </div>

                        <div v-if="stepIndex == 1" class="reset-box">
                            <el-form class="snack-form" ref="resetPhone" :model="resetPhone" :rules="resetRulesPhone" label-width="0px">
                                <el-form-item prop="phone" :error="errorMsg">
                                    <span class="field-label">注册手机号</span>
                                    <el-input class="snack-input" v-model.number="resetPhone.phone" maxlength="11" placeholder="请输入注册手机号"></el-input>
                                </el-form-item>
                                <el-form-item prop="smsVerificationCode" class="code-item">
                                    <span class="field-label">短信验证码</span>
                                    <el-input class="snack-input" v-model.number="resetPhone.smsVerificationCode" maxlength="6" placeholder="请输入验证码"></el-input>
                                    <div class="code-text-abs" v-if="!isSend" @click="getResetEnterpriseCode">获取验证码</div>
                                    <div class="code-text-abs no" v-if="isSend">重新发送{{ count }}s</div>
                                </el-form-item>
                                <el-form-item>
                                    <div
                                        class="login-btn"
                                        :class="resetPhone.phone && resetPhone.smsVerificationCode ? '' : 'gray-btn'"
                                        @click="toNext('resetPhone')"
                                    >下一步</div>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div v-if="stepIndex == 2" class="reset-box">
                            <el-form class="snack-form phone-box" ref="resetPass" :model="resetPass" :rules="resetRulesPass" label-width="0px">
                                <el-form-item prop="passWord" :error="errorMsg">
                                    <div class="pass-box">
                                        <p>新密码</p>
                                        <el-input class="snack-input" v-model="resetPass.passWord" maxlength="11" autocomplete="off" placeholder="请输入新密码" show-password auto-complete="new-password"></el-input>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="newpassword">
                                    <div class="pass-box">
                                        <p>确认新密码</p>
                                        <el-input class="snack-input" v-model="resetPass.newpassword" maxlength="11" autocomplete="off" placeholder="请输入确认新密码" show-password auto-complete="new-password"></el-input>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <div class="login-btn" @click="toSubmit('resetPass')">提交</div>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div class="back-login" @click="toChange">
                            <img src="@/assets/image/login/back.png" alt="">
                            <p>返回登录</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="snack-footer">
            <span>青岛云丝数据科技有限公司 © 2016–2026</span>
            <span>咨询方法 × 数字化系统 × 休食品类实战</span>
            <a href="https://www.yunsidata.com/" target="_blank">关于云丝</a>
            <a href="https://www.yunsidata.com/qdzs" target="_blank">联系我们</a>
            <a href="http://beian.miit.gov.cn" target="_blank">鲁ICP备2022040725号-1</a>
        </footer>
    </div>
</template>
<script>
import SilderVerify from '@/components/login/SilderVerify'
import { qrCodeGet } from '@/assets/js/common.js'
export default {
    name: "Login",
    components: {
        SilderVerify
    },
    data() {
        const validatestatus = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请拖动滑块完成验证'))
            } else {
                callback()
            }
        }
        const validatephone = (rule, value, callback) => {
            let reg = /^1[0-9]{10}$/;
            console.log(value)
            console.log(reg.test(value))
            console.log(value.toString().length)
            if (!value) {
                callback(new Error('请输入手机号'))
            } else if (value.toString().length != 11) {
                callback(new Error('请输入正确的手机号'))
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'))
            } else {
                callback()
            }
        }
        let VUE_APP_URL = process.env.VUE_APP_LOCALHOST ? process.env.VUE_APP_LOCALHOST : `${window.location.protocol}//${window.location.host}`
        var validatePass = (rule, value, callback) => {
            var passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (!passwordreg.test(value)) {
                callback(new Error('密码必须包含字母和数字，不能有特殊字符'));
            } else {
                callback();
            }
        }
        var validatePass2 = (rule, value, callback) => {
            var passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.resetPass.passWord) {
                callback(new Error('两次输入密码不一致!'));
            } else if (!passwordreg.test(value)) {
                callback(new Error('密码必须包含字母和数字，不能有特殊字符'));
            } else {
                callback();
            }
        }
        return {
            VUE_APP_URL: VUE_APP_URL,
            activeName: '0',
            formPass: {
                userName: '',
                password: '',
                status: false,
                rememberUserName: 'N'
            },
            params: {
                loginWay: '0' //0用户名密码登录 1短信登录 2微信登录 3扫码登录 4pc端监控中心登录
            },
            formPhone: {
                phone: '',
                smsVerificationCode: '',
            },
            rulesPass: {
                userName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                status: [
                    { validator: validatestatus, trigger: "change" }
                ]
            },
            rulesPhone: {
                phone: [
                    { validator: validatephone, trigger: 'blur' },
                ],
                smsVerificationCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ]
            },
            isAgree: 'Y',
            isSend: false,
            timer: null,
            count: 60,
            scanID: '',
            accountInfo: {},
            loading: '',
            isReset: false,
            stepIndex: 1,
            resetPhone: {
                phone: '',
                smsVerificationCode: '',
            },
            resetPass: {
                passWord: '',
                newpassword: '',
            },
            resetRulesPhone: {
                phone: [
                    { validator: validatephone, trigger: 'blur' },
                ],
                smsVerificationCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ],
            },
            resetRulesPass: {
                passWord: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                newpassword: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            },
            errorMsg: '',
            codeLoading: false,
            imgUrl: '',
            codeTimer: null,
            isOverdue: false,
            enterpriseCode: '',
            isModify: false, //修改密码
            resloading: null,
            isExperience: false, //是否是体验账号登录
            formExperience: {
                verifyCode: '',
                phone: ''
            },
            featureIndex: 0,
            featureTimer: null,
            featureList: [
                {
                    index: '01 / DATA DECISION',
                    navNo: '01',
                    nav: '数据决策',
                    title: '大数据决策与智能提醒',
                    desc: '问题提前暴露，机会自动浮现——从客户、商品、订单、动销、毛利、欠款中识别异常，并生成可执行线索。',
                    details: [
                        { label: '销量异常', text: '客户近期销售下滑，提醒追回' },
                        { label: '综合毛利率低', text: '提示调结构、换品项、控费用' },
                        { label: '欠款超期', text: '形成催收任务，降低风险' },
                        { label: '未拜访/超期', text: '自动提醒业务员回访' }
                    ],
                    tags: ['缸效', '坪效', '风险预警', '增长线索'],
                    highlights: ['缸效', '坪效'],
                    strategy: false,
                    value: '不是让老板看更多报表，而是告诉：哪里有问题、严重程度、谁来处理、什么时候完成。',
                    visual: '<div class="data-map"><div class="data-source"><span class="mini-node">客户 / 订单</span><span class="mini-node">商品动销</span><span class="mini-node">毛利 / 欠款</span><span class="mini-node">拜访轨迹</span></div><div class="data-engine">识别</div><div class="data-result"><span class="mini-node">异常预警</span><span class="mini-node">增长机会</span><span class="mini-node">可执行任务</span><span class="mini-node">责任到人</span></div></div><div class="visual-caption">从“看报表”升级为“系统告诉你下一步”</div>'
                },
                {
                    index: '02 / CLOSED LOOP',
                    navNo: '02',
                    nav: '闭环管理',
                    title: '经营任务闭环管理',
                    desc: '把经营策略拆成到店、到品、到费用、到欠款、到过程动作的现场任务，让业务员到店就知道：这家店有什么问题、该完成什么、结果如何反馈。',
                    details: [
                        { label: '选客户', text: '按经营问题或目标筛选门店' },
                        { label: '定任务', text: '销售 / 欠款 / 品项 / 费用等类型' },
                        { label: '绑商品', text: '关联单品、金额或动作标准' },
                        { label: '验结果', text: '审核完成情况并关联绩效' }
                    ],
                    tags: ['任务实时推送', '现场反馈留痕', '逾期自动提醒', '结果可审核'],
                    highlights: [],
                    strategy: false,
                    value: '系统不只展示数据，而是把问题转成任务，再把任务与绩效联动。',
                    visual: '<div class="loop-grid"><div class="loop-node"><b>任务</b>策略拆动作</div><div class="loop-node"><b>执行</b>业务到现场</div><div class="loop-node"><b>反馈</b>照片与单据</div><div class="loop-node"><b>复盘</b>持续优化</div><div class="loop-center">经营<br>闭环</div></div><div class="loop-steps"><span>选客户</span><i>→</i><span>定任务</span><i>→</i><span>绑商品</span><i>→</i><span>验结果</span></div><div class="visual-caption">让正确动作在团队中持续发生</div>'
                },
                {
                    index: '03 / STORE × PRODUCT',
                    navNo: '03',
                    nav: '货店匹配',
                    title: '货店匹配与精准动销',
                    desc: '把客户标签、商品标签、价格带、动销周期及必上品、利润品组合起来，形成门店推荐逻辑，让业务员更容易卖。',
                    details: [
                        { label: '客户标签化', text: 'A/B/C类、店型、区域、拜访周期、风险状态' },
                        { label: '商品标签化', text: '必上品、利润品、推广品、价格带、包装规格' },
                        { label: '动销周期化', text: '该复购、未铺货、长期不动销一目了然' },
                        { label: '推荐动作化', text: '到店直接告诉：该推什么、该补什么' }
                    ],
                    tags: ['掉品核查', '效期调改', '必上品', '利润品'],
                    highlights: ['必上品', '利润品'],
                    strategy: false,
                    value: '智能识别大日期产品，指导员工店内调改，减少库存损耗。',
                    visual: '<div class="match-columns"><div class="match-card"><strong>门店画像</strong><span>A/B/C类客户</span><span>店型与价格带</span><span>拜访与风险状态</span><span>区域与动销节奏</span></div><div class="match-arrow">×</div><div class="match-card"><strong>商品画像</strong><span>必上品 / 利润品</span><span>推广品与价格带</span><span>包装规格与效期</span><span>复购与不动销</span></div></div><div class="match-output">生成门店专属推荐清单 → 该推 / 该补 / 该调</div>'
                },
                {
                    index: '04 / ACTION × PERFORMANCE',
                    navNo: '04',
                    nav: '绩效联动',
                    title: '增长动作与绩效联动',
                    desc: '绩效工资分红：为“正确动作”付钱。不是只奖励销售额，而是奖励真正能带来利润改善的标准化动作。',
                    details: [
                        { label: '新店开发', text: '有效新客户达标计绩效' },
                        { label: '必上品铺货', text: '门店品项补齐计绩效' },
                        { label: '利润品推广', text: '结构提升计绩效' },
                        { label: '欠款 / 临期', text: '风险下降、损耗降低计绩效' }
                    ],
                    tags: ['动作 → 结果 → 审核 → 绩效'],
                    highlights: [],
                    strategy: true,
                    value: '把“老板希望员工做的事”变成“员工愿意持续做的事”。',
                    visual: '<div class="reward-list reward-grid"><div class="reward-row"><span>新店开发</span><b>+¥</b></div><div class="reward-row"><span>必上品铺货</span><b>+¥</b></div><div class="reward-row"><span>利润品推广</span><b>+¥</b></div><div class="reward-row"><span>陈列执行</span><b>+¥</b></div><div class="reward-row"><span>欠款回收</span><b>+¥</b></div><div class="reward-row"><span>临期处理</span><b>+¥</b></div></div><div class="reward-total"><span>正确动作</span><span>→ 结果 → 审核 → 绩效</span></div>'
                }
            ],
            rulesExperience: {
                phone: [
                    { validator: validatephone, trigger: 'blur' },
                ],
                verifyCode: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                ]
            },
        }
    },
    created() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null;
        }
        if (this.codeTimer) {
            clearInterval(this.codeTimer)
            this.codeTimer = null
        }
        let rememberUserNameStr = this.$cookies.get("rememberUserName")
        let arr = rememberUserNameStr ? rememberUserNameStr.split('ILOVELXZ') : []
        console.log(arr)
        if (arr.length > 1 && arr[1] == 'Y') {
            this.formPass.userName = arr[0]
            this.formPass.rememberUserName = 'Y'
        }
    },
    mounted() {
        this._prevHtmlOverflow = document.documentElement.style.overflow
        this._prevBodyOverflow = document.body.style.overflow
        document.documentElement.style.overflow = 'hidden'
        document.body.style.overflow = 'hidden'
        this.featureTimer = setInterval(() => {
            this.nextFeature()
        }, 6000)
    },
    beforeDestroy() {
        document.documentElement.style.overflow = this._prevHtmlOverflow || ''
        document.body.style.overflow = this._prevBodyOverflow || ''
        if (this.featureTimer) {
            clearInterval(this.featureTimer)
            this.featureTimer = null
        }
        if (this.codeTimer) {
            clearInterval(this.codeTimer)
            this.codeTimer = null
        }
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    },
    computed: {},
    methods: {
        setFeature(i) {
            this.featureIndex = i
            this.resetFeatureTimer()
        },
        nextFeature(manual) {
            this.featureIndex = (this.featureIndex + 1) % this.featureList.length
            if (manual) this.resetFeatureTimer()
        },
        prevFeature() {
            this.featureIndex = (this.featureIndex - 1 + this.featureList.length) % this.featureList.length
            this.resetFeatureTimer()
        },
        resetFeatureTimer() {
            if (this.featureTimer) {
                clearInterval(this.featureTimer)
                this.featureTimer = null
            }
            this.featureTimer = setInterval(() => {
                this.nextFeature()
            }, 6000)
        },
        switchLoginTab(way) {
            this.errorMsg = ''
            this.formPass.status = false
            if (way === '3') {
                this.toCurrent('3')
            } else {
                this.activeName = way
                this.params.loginWay = way
                this.toCurrent()
            }
        },
        handleClick(e) {
            console.log(this.activeName)
            this.params.loginWay = this.activeName
            e.$children[0].resetFields()
            this.errorMsg = ''
            this.formPass.status = false
        },
        handleSuccess() {
            this.formPass.status = true
            this.$refs.formPass.validateField("status")
        },
        handleMouseDown() {
            if (this.formPass.password) this.$refs.formPass.validateField("password")
            if (this.formPass.userName) this.$refs.formPass.validateField("userName")
        },
        toChange(type) { //1. 重置密码成功，清空密码
            if (type == 1) {
                this.formPass.password = ''
                this.formPass.status = false
            }
            if (this.isModify) {
                this.formPass.status = false
            }
            this.formPass.status = false
            if (this.$refs.formPass && !this.isModify && !type) this.$refs.formPass.resetFields()
            if (this.$refs.resetPhone) this.$refs.resetPhone.resetFields()
            if (this.$refs.resetPass) this.$refs.resetPass.resetFields()
            this.stepIndex = 1
            this.errorMsg = ''
            this.isReset = !this.isReset
            this.isSend = false
            clearInterval(this.timer);
            this.timer = null;
            console.log(this.formPass.status, this.isModify)
        },
        async toSend() {
            if (!this.formPhone.phone) return this.$refs.formPhone.validateField("phone")
            this.errorMsg = ''
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/getVerificationCodeNew.html', { phone: this.formPhone.phone })
            console.log(res)
            if (res.code != '0') return this.errorMsg = res.message
            this.getCode()
        },
        getCode() {
            this.isSend = true;
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.isSend = true;
                this.timer = setInterval(() => {
                    if (this.count > 1 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.isSend = false;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        toCurrent(tag) {
            this.params.loginWay = tag ? tag : this.activeName
            if (tag) {
                this.getQrCode()
            } else {
                if (this.codeTimer) {
                    clearInterval(this.codeTimer)
                    this.codeTimer = null
                }
            }
            this.formPass.status = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    if (formName == 'formExperience') {
                        this.getExperienceLogin()
                    } else {
                        this.getEnterpriseCode()
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getEnterpriseCode(type) { //1。扫码登录
            let obj = {
                userName: this.params.loginWay == '0' ? this.formPass.userName : '',
                phone: this.params.loginWay == '1' ? this.formPhone.phone : '',
                scanID: this.params.loginWay == '3' ? this.scanID : '',
            }
            this.params = { ...this.params, ...obj }
            if (!type) {
                this.loading = this.$loading({
                    lock: true,
                    text: '正在获取企业信息...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            }
            this.errorMsg = ''
            const { data: res } = await this.$http.post('/getEnterpriseCodeForVue.html', this.Qs.stringify(this.params))
            if (res.code != 'success') {
                if (!type) {
                    this.loading.close()
                    return this.errorMsg = res.message
                } else {
                    return false
                }
            }
            if (type == 1) { //扫码登录
                if (this.codeTimer) {
                    clearInterval(this.codeTimer)
                    this.codeTimer = null
                }
            }
            this.accountInfo = JSON.parse(JSON.parse(res.result).data)
            this.getLogin(type)
        },
        async getLogin(type) {
            let obj = {
                loginType: '0',
                password: this.params.loginWay == '0' ? this.formPass.password : '',
                rememberUserName: this.params.loginWay == '0' ? this.formPass.rememberUserName : '',
                smsVerificationCode: this.params.loginWay == '1' ? this.formPhone.smsVerificationCode : '',
            }
            this.errorMsg = ''
            this.params = { ...this.params, ...obj }
            console.log(this.params)
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/loginValidate.html', this.params)
            if (!type) {
                this.loading.close()
            }
            if (res.code != '0') {
                if (!type) {
                    return this.errorMsg = res.message
                } else {
                    return this.$message.error(res.message)
                }
            }
            this.getPower()
            let confirmResult = ''
            if (res.data.pwdIsOver == 'Y' && this.params.loginWay == '0') { //用户名密码验证修改密码
                confirmResult = await this.$confirm('当前登录密码已过期，是否及时修改密码', "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: '下一次',
                    showCancelButton: true,
                    type: "info",
                }).catch(err => err)
            }
            if (confirmResult == 'confirm') {
                this.isModify = true
                return this.toChange()
            }
            if (res.data.isSharedWareAndDelivery == 'G') {
                const { data: kaililaiRes } = await this.$post('/factory-portal/req/1.0/login/epLogin', { ...this.params, passwd: this.params.password })
                if (kaililaiRes.code != 200) return this.$message.error(res.message)
                sessionStorage.setItem('kaililaiToken', JSON.stringify(kaililaiRes.data))
                let url = this.VUE_APP_URL + '/yunsifactory/index.html'
                if (process.env.VUE_APP_LOCALHOST) {
                    window.location.replace(url)
                } else {
                    window.location.href = url
                }
            } else {
                let url = ''
                if (this.accountInfo.isVuePage == 'Y') {
                    url = this.VUE_APP_URL + (process.env.VUE_APP_LOCALHOST ? '/#home' : '/templates/vue-account/dist/index.htm#/home')
                } else {
                    url = this.VUE_APP_URL + '/Account/MainMerge.html'
                }
                console.log(this.VUE_APP_URL)
                console.log(url)
                if (process.env.VUE_APP_LOCALHOST) {
                    window.location.replace(url)
                } else {
                    window.location.href = url
                }
            }

        },
        toNext(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.getVerifyPhone()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getResetEnterpriseCode() {
            if (!this.resetPhone.phone) return this.$refs.resetPhone.validateField("phone")
            let obj = {
                phone: this.resetPhone.phone,
                loginWay: '4'
            }
            this.errorMsg = ''
            this.resloading = this.$loading({
                lock: true,
                text: '正在获取验证码...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post('/getEnterpriseCodeForVue.html', this.Qs.stringify(obj))
            if (res.code != 'success') {
                this.resloading.close()
                return this.errorMsg = res.message
            }
            let data = JSON.parse(JSON.parse(res.result).data)
            this.enterpriseCode = data.enterpriseCode
            this.toResetSend()
        },
        async toResetSend() {
            this.errorMsg = ''
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/getVerificationCodeNew.html', { phone: this.resetPhone.phone })
            this.resloading.close()
            if (res.code != '0') return this.errorMsg = res.message
            this.getCode()
        },
        async getVerifyPhone() {
            let obj = {
                phone: this.resetPhone.phone,
                smsVerificationCode: this.resetPhone.smsVerificationCode,
            }
            let load = this.$loading({
                lock: true,
                text: '验证中，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.errorMsg = ''
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/verificationPhoneCode.html', obj)
            load.close()
            if (res.code != '0') return this.errorMsg = res.message
            this.stepIndex = 2
        },
        toSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.updatePassword()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async getQrCode() {
            this.codeLoading = true
            this.isOverdue = false
            const { data: res } = await qrCodeGet('/erpnew/c/reada46ceb/getQRCode.html')
            const myBlob = new window.Blob([res], { type: 'image/jpeg' })
            const qrUrl = window.URL.createObjectURL(myBlob)
            this.imgUrl = qrUrl
            this.codeLoading = false
            this.codeStatus()
        },
        codeStatus() {
            if (!this.codeTimer) {
                this.codeTimer = setInterval(() => {
                    console.log(this.$cookies.get("scan_id_pc"))
                    if (this.$cookies.get("scan_id_pc")) {
                        this.isOverdue = false
                        this.scanID = this.$cookies.get("scan_id_pc")
                        this.getEnterpriseCode(1)
                    } else {
                        clearInterval(this.codeTimer);
                        this.codeTimer = null;
                        this.isOverdue = true
                    }
                }, 2000)
            }
        },
        async updatePassword() {
            let obj = {
                phone: this.resetPhone.phone,
                smsVerificationCode: this.resetPhone.smsVerificationCode,
                passWord: this.resetPass.passWord,
                enterpriseCode: this.enterpriseCode
            }
            let load = this.$loading({
                lock: true,
                text: '重置中，请稍后...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.errorMsg = ''
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/updatePasswordNew.html', obj)
            load.close()
            if (res.code != '0') return this.errorMsg = res.message
            this.$message.success('重置成功')
            this.toChange(1)
        },
        // 获取权限
        async getPower() {
            const { data: res } = await this.$http.post('/Account/dataSearchVue/selectColAndAuthByFuncCode.html', this.Qs.stringify({ funcCode: 201 }))
            // this.isGetPower = true
            if (res.code != 'success') return false
            res.result = JSON.parse(res.result)
            this.$store.commit('getPower', JSON.parse(res.result.data))
        },
        async toSendExperience() {
            if (!this.formExperience.phone) return this.$refs.formExperience.validateField("phone")
            this.errorMsg = ''
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/getVerificationCodeNew.html', { phone: this.formExperience.phone })
            console.log(res)
            if (res.code != '0') return this.errorMsg = res.message
            this.getCode()
        },
        toExchangeExperience() {
            this.isExperience = !this.isExperience
            this.errorMsg = ''
            this.formPass.status = false
        },
        async getExperienceLogin() {
            let obj = { ...this.formExperience, ...{ isMobile: false } }
            this.errorMsg = ''
            let _loading = this.$loading({
                lock: true,
                text: '正在登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$post('/erpnew/c/reada46ceb/trialUserReg.html', obj)
            _loading.close()
            if (res.code != '0') return this.errorMsg = res.message
            this.getPower()
            let url = this.VUE_APP_URL + (process.env.VUE_APP_LOCALHOST ? '/#home' : '/templates/vue-account/dist/index.htm#/home')
            console.log(this.VUE_APP_URL)
            console.log(url)
            if (process.env.VUE_APP_LOCALHOST) {
                window.location.replace(url)
            } else {
                window.location.href = url
            }
        },
    }
}
</script>
<style lang="less" scoped>
.snack-login-page {
    --bg: #f4f1ea;
    --paper: #fffdf9;
    --ink: #19211e;
    --muted: #727a75;
    --line: #e7e2d8;
    --brand: #f15a2b;
    --brand-dark: #d9461f;
    --brand-soft: #fff0e8;
    --forest: #123a32;
    --forest-deep: #0b3d32;
    --gold: #f2b94b;
    --green: #2f9b73;
    font-size: 16px;
    height: 100%;
    max-height: 100vh;
    max-height: 100dvh;
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
    overflow: hidden;
    background: var(--bg);
    position: relative;
    color: var(--ink);
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;

    &::before,
    &::after {
        content: "";
        position: absolute;
        border-radius: 50%;
        pointer-events: none;
    }
    &::before {
        width: 520px;
        height: 520px;
        right: -280px;
        top: -260px;
        background: rgba(241, 90, 43, .08);
    }
    &::after {
        width: 360px;
        height: 360px;
        left: -230px;
        bottom: -210px;
        background: rgba(18, 58, 50, .08);
    }
}

.snack-topbar {
    min-height: 58px;
    display: grid;
    grid-template-columns: auto minmax(280px, 1fr) auto;
    align-items: center;
    gap: 2rem;
    padding: 0.5rem 2rem;
    position: relative;
    z-index: 3;
}

.brand {
    display: flex;
    align-items: center;
    gap: 12px;
}
.brand-mark {
    width: 38px;
    height: 38px;
    display: grid;
    place-items: center;
    color: #fff;
    background: var(--brand);
    border-radius: 13px;
    box-shadow: 0 8px 20px rgba(241, 90, 43, .22);
    svg { width: 23px; height: 23px; }
}
.brand-copy {
    display: flex;
    align-items: center;
    white-space: nowrap;
}
.brand-name {
    font-size: 1.5rem;
    font-weight: 650;
    letter-spacing: .02em;
    color: var(--ink);
}
.edition {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    margin-left: 10px;
    padding: 0 10px;
    color: var(--brand-dark);
    background: var(--brand-soft);
    border: 1px solid rgba(241, 90, 43, .35);
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .02em;
}
.header-slogan {
    min-width: 0;
    display: grid;
    gap: 2px;
    padding-left: 22px;
    border-left: 1px solid #d8c49c;
    span {
        color: #69716c;
        font-size: 11px;
        line-height: 1.4;
        letter-spacing: .02em;
    }
    strong {
        color: var(--brand-dark);
        font-size: 12px;
        font-weight: 650;
        letter-spacing: .01em;
    }
}
.top-actions {
    display: flex;
    align-items: center;
    gap: 20px;
    color: var(--muted);
    font-size: 13px;
}
.top-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--muted);
    text-decoration: none;
    font-size: 13px;
    svg {
        width: 16px;
        height: 16px;
    }
    &:hover { color: var(--brand); }
}
.service {
    display: flex;
    align-items: baseline;
    white-space: nowrap;
    span {
        margin-right: 6px;
        font-size: 12px;
        color: var(--muted);
    }
    strong {
        color: var(--ink);
        font-size: 15px;
        font-weight: 650;
        letter-spacing: .01em;
    }
}

.snack-stage {
    min-height: 0;
    display: flex;
    align-items: stretch;
    justify-content: center;
    padding: 0.75rem 1.25rem;
    position: relative;
    z-index: 2;
}

.snack-card {
    width: ~"min(110rem, 100%)";
    height: 100%;
    min-height: 0;
    max-height: none;
    display: grid;
    grid-template-columns: minmax(0, 1.55fr) minmax(22rem, 0.9fr);
    border-radius: 1.5rem;
    overflow: hidden;
    box-shadow: 0 1.75rem 4.375rem rgba(30, 42, 36, .14);
    background: var(--paper);
    border: 1px solid rgba(255, 255, 255, .65);
}

.snack-hero {
    min-width: 0;
    min-height: 0;
    position: relative;
    overflow: hidden;
    padding: 1.35rem 1.75rem 1rem;
    color: #fff;
    background:
        radial-gradient(circle at 82% 18%, rgba(242, 185, 75, .20), transparent 23%),
        radial-gradient(circle at 0% 100%, rgba(241, 90, 43, .28), transparent 33%),
        linear-gradient(145deg, var(--forest), var(--forest-deep));
    display: flex;
    flex-direction: column;

    &::before {
        content: "";
        position: absolute;
        width: 440px;
        height: 440px;
        right: -175px;
        bottom: -190px;
        border: 70px solid rgba(255, 255, 255, .035);
        border-radius: 50%;
    }
}

.hero-portrait {
    width: 34%; max-width: 30rem; min-width: 14rem;
    position: absolute;
    z-index: 0;
    right: 0;
    top: 4%;
    bottom: 6%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    pointer-events: none;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 2;
        background:
            linear-gradient(90deg, var(--forest) 0%, rgba(18, 58, 50, .55) 22%, transparent 56%),
            linear-gradient(0deg, var(--forest-deep) 0%, transparent 24%);
    }
    img {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
        object-fit: contain;
        object-position: right top;
        opacity: .32;
        filter: saturate(.72) contrast(1.02) brightness(.88);
    }
}

.hero-inner {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: none;
    min-height: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.hero-kicker {
    display: inline-flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 0.5rem;
    color: #f8d995;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: .08em;
    &::before {
        content: "";
        width: 24px;
        height: 2px;
        background: var(--gold);
    }
}

.snack-hero h1 {
    max-width: 52rem;
    margin: 0;
    font-size: 2.25rem;
    line-height: 1.28;
    letter-spacing: -.03em;
    font-weight: 650;
    em {
        color: #ffca65;
        font-style: normal;
    }
}

.hero-desc {
    max-width: 720px;
    margin: 0.5rem 0 0;
    color: rgba(255, 255, 255, .76);
    font-size: 13px;
    line-height: 1.55;
    strong {
        color: #fff;
        font-weight: 600;
    }
}

.feature-carousel {
    margin-top: 0.75rem;
    position: relative;
    border: 1px solid rgba(255, 255, 255, .11);
    border-radius: 1.25rem;
    background: rgba(255, 255, 255, .07);
    overflow: hidden;
    /* 吃掉标题与底部之间的剩余高度，避免中间空绿 */
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.feature-stage {
    flex: 1 1 auto;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
}

.feature-slide {
    flex: 1 1 auto;
    min-height: 0;
    height: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(240px, .95fr);
    align-items: stretch;
    gap: 1rem;
    padding: 0.85rem 1.15rem;
    animation: snack-slide-in .45s ease both;
}

@keyframes snack-slide-in {
    from { opacity: 0; transform: translateX(18px); }
    to { opacity: 1; transform: translateX(0); }
}

.slide-copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    overflow: hidden;
}
.slide-index {
    color: #f8d995;
    font-size: 14px;
    font-weight: 650;
    letter-spacing: .12em;
}
.slide-copy h2 {
    margin: 8px 0 8px;
    font-size: 1.65rem;
    line-height: 1.3;
    font-weight: 620;
}
.slide-copy > p {
    max-width: 38rem;
    margin: 0;
    color: rgba(255, 255, 255, .64);
    font-size: 15px;
    line-height: 1.6;
}
.feature-details {
    list-style: none;
    margin: 12px 0 0;
    padding: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 12px;
    li {
        min-width: 0;
        padding: 9px 11px;
        background: rgba(255, 255, 255, .07);
        border: 1px solid rgba(255, 255, 255, .08);
        border-radius: 8px;
    }
    strong {
        display: block;
        color: #ffcf73;
        font-size: 15px;
        font-weight: 650;
        line-height: 1.3;
    }
    span {
        display: block;
        margin-top: 4px;
        color: rgba(255, 255, 255, .62);
        font-size: 14px;
        line-height: 1.45;
    }
}
.feature-value {
    margin: 10px 0 0 !important;
    padding: 9px 11px;
    max-width: none !important;
    color: rgba(255, 236, 196, .88) !important;
    background: rgba(242, 185, 75, .1);
    border-left: 3px solid var(--gold);
    border-radius: 0 8px 8px 0;
    font-size: 14px !important;
    line-height: 1.5 !important;
}
.feature-points {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-top: 10px;
    span {
        padding: 6px 11px;
        color: rgba(255, 255, 255, .78);
        background: rgba(255, 255, 255, .075);
        border-radius: 7px;
        font-size: 14px;
        line-height: 1.35;
    }
    .metric-highlight {
        color: var(--forest-deep);
        background: var(--gold);
        font-weight: 700;
    }
    &.strategy-line span {
        color: #ffe0a0;
        background: rgba(242, 185, 75, .12);
        border: 1px solid rgba(242, 185, 75, .2);
    }
}

.slide-visual {
    min-height: 0;
    height: 100%;
    display: grid;
    align-content: center;
    gap: 10px;
    padding: 0.85rem;
    border: 1px solid rgba(255, 255, 255, .1);
    border-radius: 16px;
    background: rgba(5, 26, 22, .28);
}

/deep/ .data-map {
    display: grid;
    grid-template-columns: 1fr 60px 1fr;
    align-items: center;
    gap: 10px;
}
/deep/ .data-source,
/deep/ .data-result { display: grid; gap: 10px; }
/deep/ .mini-node {
    padding: 12px 13px;
    color: rgba(255, 255, 255, .82);
    background: rgba(255, 255, 255, .1);
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
}
/deep/ .data-engine {
    width: 60px;
    height: 60px;
    display: grid;
    place-items: center;
    color: var(--forest-deep);
    background: var(--gold);
    border-radius: 16px;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 0 0 6px rgba(242, 185, 75, .12);
    margin: 0 auto;
}
/deep/ .visual-caption {
    color: rgba(255, 255, 255, .5);
    text-align: center;
    font-size: 13px;
    letter-spacing: .06em;
}
/deep/ .loop-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px 6px;
    margin-top: 2px;
    color: rgba(255, 255, 255, .7);
    font-size: 14px;
    span {
        padding: 4px 9px;
        background: rgba(255, 255, 255, .08);
        border-radius: 999px;
    }
    i {
        color: #ffcf73;
        font-style: normal;
    }
}
/deep/ .loop-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    position: relative;
}
/deep/ .loop-node {
    min-height: 60px;
    display: grid;
    place-items: center;
    padding: 9px;
    background: rgba(255, 255, 255, .085);
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
    b {
        display: block;
        color: #ffcf73;
        font-size: 16px;
        font-weight: 650;
    }
}
/deep/ .loop-center {
    position: absolute;
    width: 70px;
    height: 70px;
    display: grid;
    place-items: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    background: var(--brand);
    border: 5px solid var(--forest);
    border-radius: 50%;
    font-size: 13px;
    text-align: center;
    line-height: 1.2;
}
/deep/ .match-columns {
    display: grid;
    grid-template-columns: 1fr 40px 1fr;
    align-items: stretch;
    gap: 10px;
}
/deep/ .match-card {
    padding: 14px;
    background: rgba(255, 255, 255, .1);
    border-radius: 12px;
    strong {
        display: block;
        margin-bottom: 8px;
        color: #ffcf73;
        font-size: 16px;
        font-weight: 650;
    }
    span {
        display: block;
        margin-top: 6px;
        color: rgba(255, 255, 255, .7);
        font-size: 14px;
    }
}
/deep/ .match-arrow {
    display: grid;
    place-items: center;
    color: #ffcf73;
    font-size: 24px;
}
/deep/ .match-output {
    margin-top: 10px;
    padding: 12px 13px;
    color: var(--forest-deep);
    background: var(--gold);
    border-radius: 10px;
    text-align: center;
    font-size: 15px;
    font-weight: 700;
}
/deep/ .reward-list { display: grid; gap: 8px; }
/deep/ .reward-list.reward-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}
/deep/ .reward-row {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;
    padding: 12px 13px;
    background: rgba(255, 255, 255, .1);
    border-radius: 10px;
    font-size: 15px;
    b { color: #ffcf73; font-weight: 650; }
}
/deep/ .reward-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 13px;
    color: var(--forest-deep);
    background: var(--gold);
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
}

.carousel-bar {
    min-height: 44px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 0 16px 0 18px;
    border-top: 1px solid rgba(255, 255, 255, .09);
    background: rgba(6, 27, 23, .2);
}
.feature-nav {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    overflow: hidden;
}
.feature-dot {
    min-height: 36px;
    padding: 0 12px;
    color: rgba(255, 255, 255, .44);
    background: transparent;
    border: 0;
    border-radius: 8px;
    font-size: 14px;
    white-space: nowrap;
    cursor: pointer;
    b {
        margin-right: 4px;
        color: #ffcf73;
        font-weight: 650;
    }
    &[aria-current="true"] {
        color: #fff;
        background: rgba(255, 255, 255, .09);
    }
}
.carousel-arrows { display: flex; gap: 5px; }
.carousel-arrow {
    width: 29px;
    height: 29px;
    display: grid;
    place-items: center;
    color: rgba(255, 255, 255, .75);
    background: rgba(255, 255, 255, .075);
    border: 0;
    border-radius: 9px;
    cursor: pointer;
    &:hover {
        color: #fff;
        background: rgba(255, 255, 255, .13);
    }
}

.category-ribbon {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 0.65rem;
    padding-top: 0;
    flex: 0 0 auto;
    color: rgba(255, 255, 255, .48);
    font-size: 11px;
    strong { color: #f8d995; font-weight: 600; }
    span {
        padding: 4px 8px;
        border: 1px solid rgba(255, 255, 255, .12);
        border-radius: 999px;
    }
}

.proof-row {
    display: flex;
    align-items: center;
    gap: 18px;
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    flex: 0 0 auto;
    border-top: 1px solid rgba(255, 255, 255, .10);
}
.expert-avatar {
    width: 52px;
    height: 52px;
    flex: 0 0 auto;
    overflow: hidden;
    border: 3px solid rgba(255, 255, 255, .15);
    border-radius: 14px;
    background: var(--brand);
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 52% 8%;
    }
}
.expert-copy {
    min-width: 0;
    strong {
        display: block;
        font-size: 14px;
        font-weight: 600;
    }
    span {
        display: block;
        margin-top: 4px;
        color: rgba(255, 255, 255, .57);
        font-size: 11px;
        line-height: 1.5;
    }
}
.proof-stats {
    margin-left: auto;
    display: flex;
    gap: 18px;
}
.proof-stat {
    text-align: right;
    b {
        display: block;
        color: #ffca65;
        font-size: 18px;
        font-weight: 650;
    }
    small {
        color: rgba(255, 255, 255, .5);
        font-size: 10px;
    }
}

.snack-login-side {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 2.25rem;
    position: relative;
    min-height: 0;
    overflow: hidden;
    background:
        linear-gradient(rgba(255, 253, 249, .94), rgba(255, 253, 249, .94)),
        radial-gradient(circle at 30% 20%, #fff0e8, transparent 25%);

    &::after {
        content: "休食专版";
        position: absolute;
        right: 28px;
        top: 26px;
        color: rgba(25, 33, 30, .035);
        font-size: 3.5rem;
        font-weight: 700;
        letter-spacing: .05em;
        writing-mode: vertical-rl;
        pointer-events: none;
    }
}

.login-wrap {
    width: ~"min(100%, 30rem)";
    position: relative;
    z-index: 1;
}

.login-eyebrow {
    color: var(--brand);
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .1em;
}
.login-title {
    margin: 7px 0 5px;
    font-size: 1.875rem;
    line-height: 1.2;
    font-weight: 650;
    letter-spacing: -.02em;
    color: var(--ink);
}
.login-sub {
    margin: 0;
    color: var(--muted);
    font-size: 13px;
    line-height: 1.5;
}

.tabs {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
    margin: 1.25rem 0 1rem;
    padding: 4px;
    background: #f3f1ec;
    border-radius: 12px;
}
.tab {
    height: 34px;
    color: var(--muted);
    background: transparent;
    border: 0;
    border-radius: 9px;
    font-size: 13px;
    cursor: pointer;
    &[aria-selected="true"] {
        color: var(--ink);
        background: #fff;
        box-shadow: 0 4px 14px rgba(25, 33, 30, .08);
        font-weight: 600;
    }
}

.field-label {
    display: block;
    margin-bottom: 5px;
    color: #4d5550;
    font-size: 11px;
    line-height: 1.4;
    font-weight: 500;
}

.snack-form {
    /deep/ .el-form-item {
        margin-bottom: 12px;
    }
    /deep/ .el-form-item__error {
        padding-top: 2px;
    }
    /deep/ .el-input__inner {
        height: 44px;
        line-height: 44px;
        border: 1px solid var(--line);
        border-radius: 12px;
        background: #fff;
        padding: 0 14px;
        font-size: 14px;
        color: var(--ink);
        &:focus {
            border-color: var(--brand);
            box-shadow: 0 0 0 4px rgba(241, 90, 43, .10);
        }
        &::placeholder {
            color: #b0b5b1 !important;
        }
    }
}

.code-item {
    position: relative;
    /deep/ .el-input__inner {
        padding-right: 110px;
    }
}
.code-text-abs {
    position: absolute;
    right: 12px;
    bottom: 10px;
    z-index: 2;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    color: var(--brand);
    background: var(--brand-soft);
    border-radius: 8px;
    font-size: 12px;
    cursor: pointer;
    &.no {
        color: #808080;
        background: #f0eee9;
        cursor: text;
    }
}

.slider-item {
    margin-bottom: 8px !important;
    /deep/ .drag {
        width: 100% !important;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid var(--line);
    }
    /deep/ .handler {
        border-radius: 11px !important;
        color: var(--brand) !important;
    }
    /deep/ .red-bg {
        background: var(--green) !important;
    }
}

.form-options {
    margin-bottom: 14px !important;
    /deep/ .el-form-item__content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 21px;
    }
    /deep/ .el-checkbox__label {
        color: var(--muted);
        font-size: 12px;
    }
    /deep/ .el-checkbox__inner {
        border-color: #A6A6A6;
    }
    /deep/ .is-checked .el-checkbox__inner {
        border-color: var(--brand);
        background-color: var(--brand);
    }
    /deep/ .is-checked .el-checkbox__label {
        color: var(--brand);
    }
    .forgot {
        font-size: 12px;
        color: var(--brand);
        cursor: pointer;
        margin: 0;
    }
}

.login-btn {
    width: 100%;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #fff;
    background: linear-gradient(135deg, var(--brand), var(--brand-dark));
    border-radius: 12px;
    box-shadow: 0 12px 24px rgba(241, 90, 43, .24);
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: transform .18s ease, box-shadow .18s ease;
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 16px 28px rgba(241, 90, 43, .28);
    }
    &.gray-btn {
        background: #EBEBEB;
        color: #333;
        box-shadow: none;
        cursor: text;
        &:hover { transform: none; }
    }
}

.agree-box {
    margin-top: 15px;
    color: #9aa09c;
    font-size: 10px;
    line-height: 1.5;
    text-align: center;
    a {
        color: #6f7772;
        text-decoration: none;
        margin: 0 2px;
        &:hover { color: var(--brand); }
    }
}

.qr-panel {
    text-align: center;
    padding: 4px 0 12px;
    .qr {
        width: 200px;
        height: 200px;
        margin: 7px auto 18px;
        padding: 12px;
        position: relative;
        background: #fff;
        border: 1px solid var(--line);
        border-radius: 18px;
        box-shadow: 0 12px 30px rgba(25, 33, 30, .07);
        /deep/ .el-image {
            width: 100%;
            height: 100%;
        }
    }
    .qr-error {
        position: absolute;
        inset: 12px;
        background: rgba(0, 0, 0, .55);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
            font-size: 14px;
            color: #fff;
            margin: 0;
        }
        .qr-btn {
            width: 88px;
            height: 30px;
            margin-top: 10px;
            line-height: 30px;
            text-align: center;
            color: #fff;
            background: var(--brand);
            border-radius: 6px;
            font-size: 13px;
            cursor: pointer;
        }
    }
    strong {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: var(--ink);
    }
    span {
        display: block;
        margin-top: 6px;
        color: var(--muted);
        font-size: 12px;
    }
}

.reset-wrap {
    .step {
        margin: 18px 0 8px;
        display: flex;
        flex-direction: column;
    }
    .step-top {
        display: flex;
        align-items: center;
        justify-content: center;
        .line, .line1 {
            height: 1px;
            background: #E5E5E5;
            &.active { background: var(--brand); }
        }
        .line { width: 28px; }
        .line1 { width: 90px; }
        .circle {
            width: 22px;
            height: 22px;
            margin: 0 6px;
            border-radius: 50%;
            background: #E5E5E5;
            color: #A6A6A6;
            font-size: 13px;
            line-height: 22px;
            text-align: center;
            &.active {
                background: var(--brand);
                color: #fff;
            }
        }
    }
    .step-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
        padding: 0 18px;
        p {
            margin: 0;
            font-size: 14px;
            color: #383838;
            &.active { color: var(--brand); font-weight: 600; }
        }
    }
    .pass-box {
        display: flex;
        align-items: center;
        height: 44px;
        border-radius: 12px;
        border: 1px solid var(--line);
        overflow: hidden;
        background: #fff;
        p {
            width: 96px;
            margin: 0;
            border-right: 1px solid var(--line);
            font-size: 13px;
            font-weight: 500;
            line-height: 44px;
            text-align: center;
            color: #383838;
            flex-shrink: 0;
        }
        /deep/ .el-input__inner {
            border: none !important;
            box-shadow: none !important;
            border-radius: 0 !important;
        }
        /deep/ .el-input { flex: 1; }
    }
}

.back-login {
    margin-top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
        width: 18px;
        height: 18px;
        margin-right: 6px;
    }
    p {
        margin: 0;
        font-size: 14px;
        color: #808080;
    }
}

.snack-footer {
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 18px 24px;
    padding: 7px 24px;
    position: relative;
    z-index: 2;
    color: #8b918d;
    font-size: 11px;
    a {
        color: inherit;
        text-decoration: none;
    }
}


/* zoom / short viewport: tighten layout instead of clipping */
@media (max-height: 820px) {
    .snack-topbar { min-height: 3rem; padding: 0.35rem 1.25rem; }
    .header-slogan span { display: none; }
    .snack-stage { padding: 0.5rem 0.75rem; }
    .snack-card { border-radius: 1.25rem; }
    .snack-hero { padding: 1.25rem 1.5rem 1rem; }
    .hero-kicker { margin-bottom: 0.5rem; }
    .snack-hero h1 { font-size: 1.75rem; }
    .hero-desc { margin-top: 0.5rem; font-size: 0.75rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .feature-carousel { margin-top: 0.75rem; }
    .feature-slide { padding: 0.75rem 0.9rem; gap: 0.75rem; }
    .slide-copy h2 { font-size: 1.3rem; margin: 0.3rem 0 0.35rem; }
    .slide-copy > p { font-size: 13px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .feature-details { gap: 6px 10px; }
    .feature-details li { padding: 7px 9px; }
    .feature-details strong { font-size: 13px; }
    .feature-details span { display: none; }
    .feature-value { display: none; }
    .category-ribbon { display: none; }
    .proof-row { margin-top: auto; padding-top: 0.5rem; gap: 0.85rem; }
    .expert-copy span { display: none; }
    .proof-stat b { font-size: 1rem; }
    .snack-login-side { padding: 1.25rem 1.5rem; }
    .login-title { font-size: 1.5rem; }
    .snack-footer { min-height: 2.25rem; padding: 0.35rem 1rem; }
}

@media (max-height: 680px) {
    .snack-hero h1 { font-size: 1.45rem; }
    .slide-visual { display: none; }
    .feature-slide { grid-template-columns: 1fr; }
    .proof-stats { display: none; }
    .login-sub { display: none; }
}
@media (max-width: 1100px) {
    .snack-topbar {
        grid-template-columns: auto 1fr;
    }
    .header-slogan {
        justify-self: end;
        border-left: 0;
        padding-left: 0;
        text-align: right;
        span { display: none; }
    }
    .top-actions { display: none; }
    .snack-card {
        grid-template-columns: minmax(0, 1fr) minmax(340px, 400px);
    }
    .proof-stats { display: none; }
    .hero-portrait { display: none; }
    .feature-slide {
        grid-template-columns: minmax(0, 1.2fr) minmax(160px, .8fr);
    }
}

@media (max-width: 860px) {
    .snack-login-page {
        height: auto;
        min-height: 100vh;
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
    .snack-stage {
        flex: 1;
        padding: 8px 12px 16px;
    }
    .snack-card {
        height: auto;
        display: flex;
        flex-direction: column-reverse;
        border-radius: 22px;
    }
    .snack-hero {
        padding: 28px;
    }
    .header-slogan,
    .slide-visual {
        display: none;
    }
    .snack-login-side::after {
        display: none;
    }
    .feature-slide {
        grid-template-columns: 1fr;
    }
}

.snack-form /deep/ .snack-input .el-input__inner,
.snack-form /deep/ .el-input__inner {
    height: 44px;
    line-height: 44px;
    border: 1px solid var(--line);
    border-radius: 12px;
    background: #fff;
    padding: 0 14px;
    font-size: 14px;
    color: var(--ink);
}
.snack-form /deep/ .el-input__inner:focus {
    border-color: var(--brand);
    box-shadow: 0 0 0 4px rgba(241, 90, 43, .10);
}
.brand-text { display: grid; min-width: 0; }
.reset-box { margin-top: 8px; }
.phone-box { margin-top: 4px; }
.login-btn.gray-btn {
    background: #EBEBEB;
    color: #333;
    box-shadow: none;
    cursor: text;
}
.login-btn.gray-btn:hover { transform: none; }
</style>
